import React from 'react';
import Modal from '@material-ui/core/Modal';
import styles from '../../../Pages/OptionsBoard/OptionsBoardStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { firestore } from '../../../fire';
import { Button } from '@material-ui/core';
import WLDTbleHeadingRow from './components/WLDtableHeadingRow';
import WLDTableCells from './components/WLDTableCells';

const WatchListDelete = ({
  data,
  isMobile,
  showModal,
  setShowModal,
  handleClickSnak,
  userData,
}) => {
  const DeleteFav = async () => {
    const user = userData.sub;
    const concatedUser = `felix${user}`;
    let snakMessage;
    let snaktype;
    try {
      await Promise.all(
        data.map(async (onedata) => {
          await firestore
            .collection('favourite')
            .doc(concatedUser)
            .collection('data')
            .doc(onedata.id)
            .delete();
        })
      );
      snakMessage = 'Deleted from Watchlist';
      snaktype = 'success';
      handleClickSnak(snakMessage, snaktype);
    } catch (error) {
      snakMessage = 'Something went Wrong';
      snaktype = 'error';
      handleClickSnak(snakMessage, snaktype);
    }
  };
  return (
    <div style={isMobile ? { width: '220px' } : { width: '400px' }}>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <div
          style={
            isMobile
              ? styles.ToolTipboardModalContentWatchListModalMobile
              : styles.ToolTipboardModalContentWatchListModal
          }
        >
          <div
            onClick={() => setShowModal(false)}
            style={
              !isMobile
                ? { ...styles.modalCloseButton, marginTop: '2px' }
                : { ...styles.modalCloseButtonMobile, marginTop: '2px' }
            }
          >
            X
          </div>

          <div style={{ ...styles.ModalTable, width: '90%' }}>
            <div style={styles.AreYouSureText}>
              <div>Are you sure that you want to Delete?</div>
            </div>
            <Table style={{ tableLayout: isMobile ? 'fixed' : '' }}>
              <WLDTbleHeadingRow styles={styles} isMobile={isMobile} />
              <TableBody>
                {data.map((row, index) => {
                  return (
                    <WLDTableCells row={row} mykey={index} styles={styles} />
                  );
                })}
              </TableBody>
            </Table>

            <div style={styles.AreYouSureText}>
              <Button
                id="btnGO"
                variant="contained"
                style={{
                  ...styles.goButton,
                  minWidth: '22px',
                  maxWidth: '22px',
                  marginTop: '8px',
                  height: '26px',
                  backgroundColor: 'darkgrey',
                  color: 'black',
                  border: '1px solid',
                  fontSize: '12px',
                }}
                onClick={() => {
                  DeleteFav();
                }}
              >
                Go
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WatchListDelete;



// WEBPACK FOOTER //
// ./src/components/Modals/WatchListDelte/index.js